import * as React from 'react';
import ExternalImagesFull from './components/ExternalImagesFull';
import discardExternalImagesOption from './data/mutators/discardExternalImagesOption';
import { isFeatureEnabled } from 'owa-feature-flags';
import isExternalImagesOptionDirty from './utils/isExternalImagesOptionDirty';
import saveExternalImagesOption from './orchestration/saveExternalImagesOption';
import { Option } from 'owa-options-core';

const ExternalImagesOption: Option = {
    key: 'externalImagesOption',
    titleStringKey: 'optionTitle_externalImages',
    searchTermsStringKey: 'optionTitle_externalImages',
    fullOptionFormSettings: {
        render: () => <ExternalImagesFull />,
        isDirty: isExternalImagesOptionDirty,
        onSave: saveExternalImagesOption,
        hideSaveDiscard: () => false,
        onDiscard: discardExternalImagesOption,
    },
    isHidden: () => !isFeatureEnabled('rp-externalImagesProxyOption'),
};

export default ExternalImagesOption;
